import * as utils from './utils'

export const ability = () => ({
  ...utils,
})
